export const ROLES = {
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  PANEL_ADMIN: 'PANEL_ADMIN',
  VIEWER: 'VIEWER',
  DEMO_USER: 'DEMO_USER'
};

export const ROLE_NAMES = {
  ACCOUNT_ADMIN: 'Account Admin',
  PANEL_ADMIN: 'Panel Admin',
  VIEWER: 'Viewer',
  DEMO_USER: 'Demo User'
};

export const resolveUserRole = (...roles) => {
  const normalizedRoles = roles
    .filter(Boolean)
    .map(role => String(role).trim().toUpperCase());

  const roleAliases = {
    DEMO: ROLES.DEMO_USER,
    DEMOUSER: ROLES.DEMO_USER,
    DEMO_USER: ROLES.DEMO_USER,
    VIEWER: ROLES.VIEWER,
    PANEL_ADMIN: ROLES.PANEL_ADMIN,
    ACCOUNT_ADMIN: ROLES.ACCOUNT_ADMIN
  };

  const matchedRole = normalizedRoles.find(role => roleAliases[role]);
  return roleAliases[matchedRole] || ROLES.VIEWER;
};
